// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1xIz2","inputWrap":"styles_inputWrap__Wz0Qn","input":"styles_input__2GEVo"};